import React, { Component } from 'react';
import { Table, Row, Button, message, Spin, DatePicker } from 'antd';
import moment from 'moment';
import { inject, observer } from "mobx-react";
import { data3_2_1 } from './data';
import imgSave from "../../../saveImg";
import Auth from "../../../Auth";
import { compute, computeNew } from "./compute";
import FileSaver from "file-saver";
import Compared from '../../../Compared';
const { MonthPicker } = DatePicker;
const totalIndex = [7, 10];
const percentindex = [15];

@inject('store')
@observer
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            dateData: [],
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            monthDataAll: {}
        }
    }

    componentDidMount() {
        this.getDateData(this.state.date);
    }

    computeNum = async (data) => {
        const newData = await computeNew(this.state.monthDataAll, data);

        this.setState({
            data: newData
        }, () => {
            if (this.state.monthDataAll.data && this.state.monthDataAll.data.length > 0) {
                this.onSave();
            }
        });
    }

    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getDateData = (date) => {
        const dataBegin = JSON.stringify(data3_2_1);
        let data = JSON.parse(dataBegin);
        const year = moment(date).format('YYYY');
        const month = moment(date).format('M');

        fetch(`/_4_2_1_info?year=${year}&month=${month}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.data && x.data.data.length > 0) {
                data = x.data.data.sort((a, b) => {
                    return a.sort - b.sort
                });
            }
            const monthDataAll = {
                data: (x.data.month || []).sort((a, b) => {
                    return a.sort - b.sort
                }),
                lastMonthData: (x.data.lastMonthData || []).sort((a, b) => {
                    return a.sort - b.sort
                }),
            };
            this.setState({ loading: false, monthDataAll }, () => {
                this.computeNum(data);
            });

        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        const year = moment(date).format('YYYY');
        const month = moment(date).format('M');
        let data = this.state.data.map((x, i) => ({ ...x, year, month }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_4_2_1', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table4_1_1', 1.5, '4.13', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });
    }

    downloadExcel = () => {
        const hotel = sessionStorage.getItem('hotelName') || "";
        const tableName = `${hotel} ${moment(this.state.date).format('YYYY')}REVENUE PLAN - MARKET SEGMENTATION ANALYSIS REPORT`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById('table4_1_3_2').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }


    render() {
        const { data, date } = this.state;
        const year = date;
        const width = document.body.offsetWidth - 2400 > 300 ? document.body.offsetWidth - 2400 : 300;

        const columns = [{
            title: 'YEAR TO DATE',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            fixed: this.state.print ? false : "left",
            width,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `} style={{ textAlign: "left" }}>
                        {text || "-"}
                    </div>
                )
            }
        }, {
            title: `Actual Last Year`,
            width: 750,
            children: [{
                title: <div>R/Nts</div>,
                dataIndex: 'budget_r_nts',
                key: 'budget_r_nts',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = [`Actual Last Year`, 'R/Nts'];
                    if (percentindex.includes(index)) {
                        return (
                            <Compared data={{ index, key: 'budget_r_nts', title, sqlName: "_4_2_rev", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                                </div>
                            </Compared>
                        )
                    }

                    return (
                        <Compared data={{ index, key: 'budget_r_nts', title, sqlName: "_4_2_rev", name: record.name, type: 'number' }}>
                            <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                {Number(text || '0') < 0 ?
                                    <span style={{ color: "red" }}>
                                        ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                    </span>
                                    :
                                    Number(text || "0").toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                }
                            </div>
                        </Compared>
                    )

                }
            }, {
                title: <div>Mix%</div>,
                dataIndex: 'budget_nts_mix',
                key: 'budget_nts_mix',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = [`Actual Last Year`, 'Mix%'];
                    if (index < 14) {
                        return (
                            <Compared data={{ index, key: 'budget_nts_mix', title, sqlName: "_4_2_rev", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                    return (
                        <div
                            className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}
                            style={{ textAlign: "right" }}
                        >
                            -
                        </div>
                    )
                }
            }, {
                title: <div>A.R.R</div>,
                dataIndex: 'budget_arr',
                key: 'budget_arr',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = [`Actual Last Year`, 'A.R.R'];
                    if (index < 14) {
                        return (
                            <Compared data={{ index, key: 'budget_arr', title, sqlName: "_4_2_rev", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                    {Number(text || '0') < 0 ?
                                        <span style={{ color: "red" }}>
                                            ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                    </span>
                                        :
                                        Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                    }
                                </div>
                            </Compared>
                        )
                    }
                    return (
                        <div
                            className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}
                            style={{ textAlign: "right" }}
                        >
                            -
                        </div>
                    )

                }

            }, {
                title: <div>Rev</div>,
                dataIndex: 'budget_rev',
                key: 'budget_rev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = [`Actual Last Year`, 'Rev'];

                    if (index < 14) {
                        return (
                            <Compared data={{ index, key: 'budget_rev', title, sqlName: "_4_2_rev", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                    {Number(text || '0') < 0 ?
                                        <span style={{ color: "red" }}>
                                            ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                    </span>
                                        :
                                        Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                    }
                                </div>
                            </Compared>
                        )
                    }

                    return (
                        <div
                            className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}
                            style={{ textAlign: "right" }}
                        >
                            -
                        </div>
                    )

                }
            }, {
                title: <div>Mix%</div>,
                dataIndex: 'budget_rev_mix',
                key: 'budget_rev_mix',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = [`Actual Last Year`, 'Mix%'];
                    if (index < 14) {
                        return (
                            <Compared data={{ index, key: 'budget_rev_mix', title, sqlName: "_4_2_rev", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                    return (
                        <div
                            className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}
                            style={{ textAlign: "right" }}
                        >
                            -
                        </div>
                    )
                }
            }]
        }, {
            title: `Whole Year Actual + Forecast`,
            width: 750,
            children: [{
                title: <div>R/Nts</div>,
                dataIndex: 'sum_r_nts',
                key: 'sum_r_nts',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = [`Whole Year Actual + Forecast`, 'R/Nts'];

                    if (percentindex.includes(index)) {
                        return (
                            <Compared data={{ index, key: 'sum_r_nts', title, sqlName: "_4_2_rev", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                                </div>
                            </Compared>
                        )
                    }

                    return (
                        <Compared data={{ index, key: 'sum_r_nts', title, sqlName: "_4_2_rev", name: record.name, type: 'number' }}>
                            <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                {Number(text || '0') < 0 ?
                                    <span style={{ color: "red" }}>
                                        ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                    </span>
                                    :
                                    Number(text || "0").toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                }
                            </div>
                        </Compared>
                    )

                }
            }, {
                title: <div>Mix%</div>,
                dataIndex: 'sum_nts_mix',
                key: 'sum_nts_mix',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = [`Whole Year Actual + Forecast`, 'Mix%'];
                    if (index < 14) {
                        return (
                            <Compared data={{ index, key: 'sum_nts_mix', title, sqlName: "_4_2_rev", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                    return (
                        <div
                            className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}
                            style={{ textAlign: "right" }}
                        >
                            -
                        </div>
                    )
                }
            }, {
                title: <div>A.R.R</div>,
                dataIndex: 'sum_arr',
                key: 'sum_arr',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = [`Whole Year Actual + Forecast`, 'A.R.R'];
                    if (index < 14) {
                        return (
                            <Compared data={{ index, key: 'sum_arr', title, sqlName: "_4_2_rev", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                    {Number(text || '0') < 0 ?
                                        <span style={{ color: "red" }}>
                                            ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                    </span>
                                        :
                                        Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                    }
                                </div>
                            </Compared>
                        )
                    }
                    return (
                        <div
                            className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}
                            style={{ textAlign: "right" }}
                        >
                            -
                        </div>
                    )

                }

            }, {
                title: <div>Rev</div>,
                dataIndex: 'sum_rev',
                key: 'sum_rev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = [`Whole Year Actual + Forecast`, 'Rev'];

                    if (index < 14) {
                        return (
                            <Compared data={{ index, key: 'sum_rev', title, sqlName: "_4_2_rev", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                    {Number(text || '0') < 0 ?
                                        <span style={{ color: "red" }}>
                                            ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                    </span>
                                        :
                                        Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                    }
                                </div>
                            </Compared>
                        )
                    }

                    return (
                        <div
                            className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}
                            style={{ textAlign: "right" }}
                        >
                            -
                        </div>
                    )

                }
            }, {
                title: <div>Mix%</div>,
                dataIndex: 'sum_rev_mix',
                key: 'sum_rev_mix',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = [`Whole Year Actual + Forecast`, 'Mix%'];
                    if (index < 14) {
                        return (
                            <Compared data={{ index, key: 'sum_rev_mix', title, sqlName: "_4_2_rev", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                    return (
                        <div
                            className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}
                            style={{ textAlign: "right" }}
                        >
                            -
                        </div>
                    )
                }
            }]
        }, {
            title: `Diff%`,
            width: 750,
            children: [{
                title: <div>R/Nts</div>,
                dataIndex: 'diff_r_nts',
                key: 'diff_r_nts',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = [`Diff%`, 'R/Nts'];

                    if (percentindex.includes(index)) {
                        return (
                            <Compared data={{ index, key: 'diff_r_nts', title, sqlName: "_4_2_rev", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                                </div>
                            </Compared>
                        )
                    }

                    return (
                        <Compared data={{ index, key: 'diff_r_nts', title, sqlName: "_4_2_rev", name: record.name, type: 'number' }}>
                            <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                {Number(text || '0') < 0 ?
                                    <span style={{ color: "red" }}>
                                        ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                    </span>
                                    :
                                    Number(text || "0").toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                }
                            </div>
                        </Compared>
                    )

                }
            }, {
                title: <div>% Diff</div>,
                dataIndex: 'diff_nts_mix',
                key: 'diff_nts_mix',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = [`Diff%`, '% Diff'];

                    return (
                        <Compared data={{ index, key: 'diff_nts_mix', title, sqlName: "_4_2_rev", name: record.name, type: 'percent' }}>
                            <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                            </div>
                        </Compared>
                    )
                }
            }, {
                title: <div>A.R.R</div>,
                dataIndex: 'diff_arr',
                key: 'diff_arr',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = [`Diff%`, 'A.R.R'];
                    if (index < 14) {
                        return (
                            <Compared data={{ index, key: 'diff_arr', title, sqlName: "_4_2_rev", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                    {Number(text || '0') < 0 ?
                                        <span style={{ color: "red" }}>
                                            ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                    </span>
                                        :
                                        Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                    }
                                </div>
                            </Compared>
                        )
                    }
                    return (
                        <div
                            className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}
                            style={{ textAlign: "right" }}
                        >
                            -
                        </div>
                    )

                }

            }, {
                title: <div>% Diff</div>,
                dataIndex: 'diff_arr_mix',
                key: 'diff_arr_mix',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = [`Diff%`, '% Diff'];
                    if (index < 14) {
                        return (
                            <Compared data={{ index, key: 'diff_arr_mix', title, sqlName: "_4_2_rev", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                    return (
                        <div
                            className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}
                            style={{ textAlign: "right" }}
                        >
                            -
                        </div>
                    )
                }
            }, {
                title: <div>Rev</div>,
                dataIndex: 'diff_rev',
                key: 'diff_rev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = [`Diff%`, 'Rev'];

                    if (index < 14) {
                        return (
                            <Compared data={{ index, key: 'diff_rev', title, sqlName: "_4_2_rev", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                    {Number(text || '0') < 0 ?
                                        <span style={{ color: "red" }}>
                                            ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                    </span>
                                        :
                                        Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                    }
                                </div>
                            </Compared>
                        )
                    }

                    return (
                        <div
                            className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}
                            style={{ textAlign: "right" }}
                        >
                            -
                        </div>
                    )

                }
            }, {
                title: <div>% Diff</div>,
                dataIndex: 'diff_rev_mix',
                key: 'diff_rev_mix',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = [`Diff%`, '% Diff'];
                    if (index < 14) {
                        return (
                            <Compared data={{ index, key: 'diff_rev_mix', title, sqlName: "_4_2_rev", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                    return (
                        <div
                            className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}
                            style={{ textAlign: "right" }}
                        >
                            -
                        </div>
                    )
                }
            }]
        }];


        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table4_1_1" style={{ width: this.state.print ? 2750 : 'auto' }}>
                        <Row>4.1.3 Yearly Market Segmentation report 年度市场细分报表</Row>
                        <Row className="table-month">

                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            id="table4_1_3_2"
                            bordered
                            pagination={false}
                            className="content"
                            style={{ width: this.state.print ? 2700 : 'auto' }}
                            scroll={this.state.print ? {} : { x: 2700, y: 500 }}
                            rowKey={(record, index) => index}
                        />
                    </Row>
                    <Row className="table-footer-btn">
                        <Button
                            type="primary"
                            onClick={() => {
                                this.setState({ print: true }, () => {
                                    this.downloadExcel();
                                });
                            }}
                            loading={this.state.print}
                        >导出Excel</Button>
                        <Auth loading={this.state.loading} auth="edit_4_1">
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                                style={{ marginLeft: 10 }}
                            >保存</Button>
                        </Auth>
                    </Row>
                </div>
            </Spin >
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/table/4.0/4-1/4-1-3/index.js